import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { Config, ErrorHandlerFactory } from './error-handler.factory';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    imports: [
        BrowserModule,
    ]
})
export class BugsnagModule {

    /**
     * Set the environment in the root module.
     *
     * @param config
     */
    public static forRoot(config: Config): ModuleWithProviders {
        const providers = config.enabled
            ? [{
                provide: ErrorHandler,
                useFactory: () => {
                    return ErrorHandlerFactory(config);
                }
            }]
            : [];

        return {
            ngModule: BugsnagModule,
            providers: providers,
        };
    }

}



// WEBPACK FOOTER //
// ./libs/bugsnag/src/bugsnag.module.ts